<template>
  <header id="header-main" class="flex flex-middle">
    <button class="menu-button" @click="toggleMobileMenu">
      <div></div>
      <div></div>
      <div></div>
    </button>
    <router-link to="/" class="logo-link"><img class="logo" src="@/assets/img/logo.png" srcset="@/assets/img/logo.png 1x, @/assets/img/logo@2x.png 2x" alt="Escuela de liderazgo"></router-link>
    <nav class="menu-desk">
      <ul class="flex clean font-bold clean-a">
        <li><router-link :to="{name:'wellbeing'}">Somos Bienestar</router-link></li>
        <li><router-link :to="{name:'school-territory'}">La Escuela en territorio</router-link></li>
      </ul>
    </nav>
    <nav :class="{'show-mobile': showMobile}" @click="toggleMobileMenu" class="menu-mobile">
      <ul class="flex clean font-bold clean-a">
        <li><router-link :to="{name:'home'}">Inicio</router-link></li>
        <li><router-link :to="{name:'wellbeing'}">Somos Bienestar</router-link></li>
        <li><router-link :to="{name:'school-territory'}">La Escuela en territorio</router-link></li>
      </ul>
    </nav>
    <NumbersHead />
  </header>
</template>

<script>
import NumbersHead from './NumbersHead';

export default {
  components: {NumbersHead},

  data() {
    return {
      showMobile: false,
    }
  },

  methods: {
    toggleMobileMenu(){
      this.showMobile = !this.showMobile;
      if(this.showMobile){
        document.body.classList.add('menu-mobile-showed');
      } else {
        document.body.classList.remove('menu-mobile-showed');
      }
    }
  },
}
</script>
